import tw, { styled } from 'twin.macro';

import { Stack } from '../../../Stack/Stack';

export const StyledSection = styled(Stack)<{ dark?: boolean; bordered?: boolean }>`
	${tw`p-6 bg-white`}
	${({ dark }) => dark && tw`bg-gray-50`}
	${({ bordered }) => bordered && tw`border-t first:border-t-0`}
`;
